import moment from 'moment';
import { AppointmentData } from '../../models';

type AppointmentConfirmationData = Pick<
  AppointmentData,
  'confirmedByClientAt' | 'deniedByClientAt' | 'confirmationRequestsSentBySms' | 'confirmationRequestsSentByWhatsapp'
>;

export type AppointmentConfirmationStatus = 'confirmed' | 'rejected' | 'pending' | null;
export type AppointmentConfirmationEditableStatus = Exclude<AppointmentConfirmationStatus, null>;

export const getAppointmentConfirmationStatus = (appointment: AppointmentConfirmationData): AppointmentConfirmationStatus => {
  if (appointment.confirmedByClientAt) return 'confirmed';
  if (appointment.deniedByClientAt) return 'rejected';

  const hasConfirmationRequestSent = (appointment.confirmationRequestsSentBySms?.length ?? 0) > 0
    || (appointment.confirmationRequestsSentByWhatsapp?.length ?? 0) > 0;

  if (!hasConfirmationRequestSent) return null;
  return 'pending';
};

export const applyAppointmentConfirmationStatus = <T extends AppointmentConfirmationData>(
  appointment: T,
  status: AppointmentConfirmationEditableStatus,
  timestamp = moment().format('YYYY-MM-DDTHH:mm:ss'),
): T => ({
  ...appointment,
  confirmedByClientAt: status === 'confirmed' ? timestamp : undefined,
  deniedByClientAt: status === 'rejected' ? timestamp : undefined,
});
